import c from "../common";

export default {
  description_1: "申請列表",
  description_2: c.vendor.chn,
  description_3: c.voucher.chn + " & " + c.discount.chn,
  billing: "結算報告",
  export: "匯出",
  price: "價錢",
  voucher: "電子卷",
  qty: "數量",
  total: "總數",
  vendor: "商家",
  recordID: "交易編號"
};
